export default __webpack_public_path__ + "static/media/Front-Apartment-Ibrahim-Al-Atat.7734ad07.jpg";